const transformListData = require("./transformListData");

module.exports = function mockListData(entity) {
	let mock_entities_list = {
		id: `media-${entity.id}`,
		type: `node--entities_list`,
		attributes: {
			field_entities_list_mode: "list",
			field_entities_list_show_filters: false,
		},
		relationships: {
			field_entities_list_by_specific: {
				data: entity.relationships.field_media.data,
			},
		},
	};

	return transformListData(mock_entities_list);
};
